import React, {  useState } from 'react'
import {Nav} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Style/Header.css'

import { Link } from 'react-router-dom';

import logo from '../Images/Logo.png'
import { useSelector, useDispatch} from 'react-redux'
import { logout } from "../Store/Actions/Auth";

import Toast from '../Helpers/Toast'

import { useLocation } from "react-router-dom";

import DropDownMenu from './DropDownMenu'

import ContactUs from './ContactUs'


const Header = () => {

  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const { isLoggedIn, user } = useSelector(state => state.auth)

  const [openMenu, setNavMenu]      = useState(false)
  const [dropdown, setDropDown]   = useState(false)
  const [menu, setMenu]       = useState(false)
  const [loading, setLoading] = useState(false);

  const [showMegaMenu, setMegaMenu] = useState(false)
  // Methods

  const toggleMenu = () =>{
    setMenu(prevState => ! prevState)  
  }

  const toggleNavMenu = () => {
    setNavMenu(state => !state)
  }

  const toggleDropDown = () => {
    setDropDown(prevState => !prevState)
  }

  // handle Logout
  const handleLogout = () => {
    setLoading(true);
    dispatch(logout())
    .then((res) => {
        setLoading(false);
        if(res.status){

          Toast.fire({
            icon: 'success',
            title: 'Logout successful.'
          })
        }
      }).catch(() => {
        setLoading(false);
      });
  }

  return (
    <div className='header bg-white shadow'>
        
      <div className='container position-relative d-flex justify-content-between align-items-center'>
        <Link onClick={()=> {
            setMenu(false)
            setDropDown(false)
          }} 
          to='/'>
            <img src={logo} alt='Logo' className='myLogo py-2'/>
        </Link>

        <div
          onClick={toggleNavMenu} 
          className="menu-toggle-btn d-block d-lg-none mx-2">
          <span></span>
          <span></span>
          <span></span>
        </div>
        
        <div className={`border-top bg-white ${openMenu ? 'd-block' : 'd-none'} d-lg-none menu d-xl-none `}>
          <Nav.Item className="aboutus_link py-2">
            <Nav.Link onClick={()=> {
                setDropDown(false)
                setMenu(false)
                setNavMenu(false)
              }} 
                className={`navitem ${pathname === '/about-us' ? 'activeLink' : ''}`} eventKey='1' as={Link} to='/about-us'>
                  About Us
            </Nav.Link>
          </Nav.Item>

          <div 
              onClick={(e) => toggleDropDown() }
              className={`dropdown-link d-flex  border-bottom justify-content-between py-2  align-items-center  ${pathname === '/academy' ? 'activeLink' : ''}`}>
              <span className={`navitem ${dropdown ? 'activeLink' : ''}`}>Our Services</span>
              <i  className='bi bi-chevron-down  text-lg dropdown-link_icon-sm mx-2' ></i>
          </div>
          { dropdown && <>
            <div className="dropdown_sm mx-3">
              <Nav.Item className="nav_item" >
                <Nav.Link onClick={()=> {
                    setDropDown(false)
                    setMenu(false)
                    setNavMenu(false)
                  }} 
                    className={`navitem ${pathname === '/academy' ? 'activeLink' : ''}`} eventKey='1' as={Link} to='/academy'>
                      Academy
                </Nav.Link>
              </Nav.Item>
              <Nav.Item className="nav_item" >
                <Nav.Link onClick={()=> {
                    setDropDown(false)
                    setMenu(false)
                    setNavMenu(false)
                  }} 
                    className={`navitem ${pathname === '/careerinpoland' ? 'activeLink' : ''}`} eventKey='1' as={Link} to='/careerinpoland'>
                      Study Abroad
                </Nav.Link>
              </Nav.Item>

              <Nav.Item className="nav_item" >
                <Nav.Link onClick={()=> {
                    setDropDown(false)
                    setMenu(false)
                    setNavMenu(false)
                  }} 
                    className={`navitem ${pathname === '/recruitment' ? 'activeLink' : ''}`} eventKey='1' as={Link} to='/recruitment'>
                      Recruitment
                </Nav.Link>
              </Nav.Item>
            </div>
          </> }

          <Nav.Item className=" border-top bg-white aboutus_link py-2 ">
            <Nav.Link onClick={()=> {
                setDropDown(false)
                setMenu(false)
                setNavMenu(false)
              }} 
                className={`navitem ${pathname === '/contact' ? 'activeLink' : ''}`} eventKey='1' as={Link} to='/contact'>
                  Contact Us
            </Nav.Link>
          </Nav.Item>
        </div>

        <div className={`m-auto h-100 d-none  d-lg-flex container justify-content-center align-items-center` }>
          <Nav.Item className="aboutus_link py-2">
            <Nav.Link onClick={()=> {
                setDropDown(false)
                setMenu(false)
              }} 
                className={`navitem ${pathname === '/about-us' ? 'activeLink' : ''}`} eventKey='1' as={Link} to='/about-us'>
                  About Us
            </Nav.Link>
          </Nav.Item>

          {/* Large Screen */}
          <Nav.Item  
            onMouseEnter={toggleDropDown} 
            onMouseLeave={toggleDropDown}

            className=' d-none d-lg-block position-relative'>
            <Nav.Link 
              onClick={(e) => {
                toggleDropDown();
                e.preventDefault();
              }}
              className={` align-items-center  ${pathname === '/academy' ? 'activeLink' : ''}`} eventKey='1' as={Link} to='/academy'>
              <span className={`main-nav_item px-4 py-5 ${dropdown ? 'activeLink' : ''}`}>Our Services</span>
            </Nav.Link>

            { dropdown && <DropDownMenu 
              pathname={pathname}
              setMenu={setMenu} 
              setDropDown={setDropDown}>
            </DropDownMenu> }
          </Nav.Item> 

          
          <Nav.Item className="bg-white aboutus_link py-2">
            <Nav.Link onClick={()=> {
                setDropDown(false)
                setMenu(false)
              }} 
                className={`navitem ${pathname === '/contact' ? 'activeLink' : ''}`} eventKey='1' as={Link} to='/contact'>
                  Contact Us
            </Nav.Link>
          </Nav.Item>

        </div>

        <div className="d-none d-lg-block py-2">
            {isLoggedIn ? 
              <>
                <Link to='/dashboard'>
                  <div 
                  
                    className='position-relative'>
                    <div className='d-flex align-items-center mx-3 py-2 py-lg-0 mx-lg-0'>
                      <span className='activeIcon mx-4'></span>
                      <span className='text-dark '>{ user.name }</span>
                    </div>
                    
                  </div>
                </Link>
              </> :
              
                <Link to='/login'><button className='signUpBtn px-5 py-2 m-auto mx-2 mt-2 mx-lg-0 mt-lg-0'>Login</button></Link>
              
            }
        </div>
      </div>
       

        
    </div>
  )
}

export default Header;